/**
 * sigla.ts — deriva la sigla del cliente a partir del nombre (frontend).
 *
 * Réplica EXACTA de la regla del backend (apps/api/src/domain/services/sigla.ts).
 * Se duplica acá a propósito: reports NO importa de admin-panel (features
 * desacoplados); es una función pequeña y pura, la duplicación es aceptable.
 *
 *   "Komatsu-Mitsui Maquinarias Peru"  → "KMMP"
 *   "Volvo"                            → "VOL"  (una sola palabra → primeras 3 letras)
 *   "Ferreyros Caterpillar Perú"       → "FCP"
 *   ""                                 → ""     (placeholder)
 */
export function deriveSigla(nombre: string): string {
  const palabras = nombre
    .trim()
    .split(/[\s-]+/)
    .map((w) => w.replace(/[^a-zA-ZÀ-ÿ]/g, ""))
    .filter(Boolean);

  if (palabras.length === 0) return "";

  if (palabras.length === 1) {
    return palabras[0]!.slice(0, 3).toUpperCase();
  }

  return palabras
    .map((w) => w[0]!)
    .join("")
    .toUpperCase();
}
